export const MAX_HUMAN_REVIEW_PROJECT_METRICS = 25
export const HUMAN_REVIEW_METRIC_LIMIT_MESSAGE =
  "You’ve selected the maximum of 25 metrics. Remove one to add another."

export class HumanReviewMetricLimitError extends Error {
  readonly code = "too_many_metrics"

  constructor() {
    super("Maximum of 25 metrics allowed.")
    this.name = "HumanReviewMetricLimitError"
  }
}

export function assertHumanReviewMetricLimit(metrics: string[] | undefined) {
  if (metrics && metrics.length > MAX_HUMAN_REVIEW_PROJECT_METRICS) {
    throw new HumanReviewMetricLimitError()
  }
}

export function isHumanReviewMetricLimitError(error: unknown): boolean {
  if (error instanceof HumanReviewMetricLimitError) {
    return true
  }
  if (!error || typeof error !== "object") {
    return false
  }
  const detail = (error as { detail?: { details?: unknown } }).detail
  const details = detail?.details ?? (error as { details?: unknown }).details
  const message = (error as { message?: unknown }).message
  return (
    message === "Maximum of 25 metrics allowed." ||
    (Array.isArray(details) &&
      details.some(
        (detail) =>
          typeof detail === "object" &&
          detail !== null &&
          (detail as { type?: unknown }).type === "too_many_metrics",
      ))
  )
}
